import React from 'react';
import { CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter, CButton } from '@coreui/react';
import { ConfirmationDataBag } from '../models/modal';

interface ConfirmationModalProps extends ConfirmationDataBag {
  show: boolean;
  close: () => void;
}

const ConfirmationModal = ({ show, close, title, message, confirmAction }: ConfirmationModalProps) => {
  const handleConfirm = () => {
    confirmAction();
    close();
  }

  return (
    <CModal className="mt-5 pt-5" id="confirmation-modal" show={ show } onClose={ close } size="sm">
      <CModalHeader closeButton>
        <CModalTitle>{ title }</CModalTitle>
      </CModalHeader>
      <CModalBody>
        { message }
      </CModalBody>
      <CModalFooter className="glympse-footer">
        <div className='glympse-btnWrapper'>
          <div className='glympse-btnWrapper'>
            <CButton
              className="pl-5 pr-5 bg-color-orange pl-5 pr-5 border-0 roundedBtn roundBottomShadow"
              color="info"
              onClick={ handleConfirm }
            >
              Continue
            </CButton>
          </div>
          <CButton
            className="glympse-cancelBtn"
            color="light"
            shape="rounded-pill"
            variant="ghost"
            onClick={ close }
          >
            Cancel
          </CButton>
        </div>
      </CModalFooter>
    </CModal>
  );
}

export default ConfirmationModal;